import apiHostAddress from './apiHostAddress';
import log from 'loglevel'

const apiAddress = (function () {
  var url = 'https://' + apiHostAddress;
  log.debug('Backend URL : ' + url)
  return url;
})();

export default apiAddress;
